import React from 'react';
import './ThankYou.css';
import { useNavigate } from 'react-router-dom';

export default function ThankYouScreen({ message }) {
    const navigate = useNavigate();

    return (
        <div className="thankyou-container">
            <img src="/app/Image/MainLogo.png" alt="Logo" className="thankyou-logo" />
            <div className="thankyou-card">
                <div className="checkmark">&#10004;</div>
                <h2>Thank You!</h2>
                <p>{message || "You have successfully completed the form."}</p>
                <button className="thankyou-btn" onClick={() => (window.location.href = "https://www.revolvingchange.com")}>
                    Go Home 
                </button>
            </div>
        </div>
    );
}